
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */



const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p><em parentName="p">{`La petite histoire`}</em></p>
    <p>{`Dans le cadre de l’essai clinique, des volontaires ont aussi reçu un vaccin
contre la grippe saisonnière. L’idée est de voir si les deux produits peuvent
être injectés en même temps. Voire, un jour, de les combiner? La compagnie a
annoncé en mai 2021 que des premiers essais sur des animaux (des furets et des
hamsters) avec un produit "deux en un" avait donné des résultats positifs.`}</p>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;